import React from 'react';
import { connect } from 'react-redux';
import StyledPopupListContainer from './list.styled';
import PopupList from './list';
import Title from '../../../Components/Common/pageTitle';

import { getPopupList } from '../../../Reducer/Modules/app';
import { editServicePage } from '../../../Reducer/Modules/service';

class PopupListPage extends React.PureComponent {
    componentDidMount = () => {
        this.props.fetchPopupList();
    };

    render() {
        return (
            <StyledPopupListContainer>
                <Title title='팝업 목록' />
                <PopupList {...this.props} />
            </StyledPopupListContainer>
        );
    }
}
const mapStateToProps = ({ app, auth, service }) => ({
    app,
    auth,
    service,
});

const mapDispatchToProps = dispatch => ({
    fetchPopupList: () => dispatch(getPopupList()),
    editPage: page => dispatch(editServicePage(page)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PopupListPage);
